import React from "react";
import s from "./HelperMessage.module.scss";

const HelperMessage = ({ message }) => {
  return <div className={s.helperMessage}>{message}</div>;
};

export default React.memo(HelperMessage);
